export default {
    path: '/aMData',
    component: () => import('@/views/layout.vue'),
    redirect: '/aMData',
    name: 'aMData',
    sort: 9,
    icon: 'el-icon-s-management',
    meta: { title: 'demo.menu.MasterData', authCode: ['MDATA001'] },
    children: [
        {
            path: '/organization',
            name: 'Organization',
            component: () => import('@/views/permission/organization/organization.vue'),
            meta: {
                title: 'demo.menu.Mechanism',
                authCode: ['R0002']
            }
        },
        {
            path: '/shiftList',
            name: 'Shift',
            component: () => import('@/views/permission/organization/shiftList.vue'),
            meta: {
                title: 'demo.menu.Shift',
                authCode: ['R0001']
            }
        },
        {
            path: '/branch',
            name: 'Branch',
            component: () => import('@/views/permission/organization/branch.vue'),
            meta: {
                title: 'demo.menu.Branch',
                authCode: ['BUMEN']
            }
        },
        {
            path: '/department',
            name: 'Department',
            component: () => import('@/views/permission/organization/department.vue'),
            meta: {
                title: 'demo.menu.Department',
                authCode: ['KESHI']
            }
        },
        {
            path: '/staff',
            name: 'staff',
            hidden: true,
            component: () => import('@/views/permission/organization/staff.vue'),
            meta: {
                title: 'demo.menu.Staff',
                authCode: ''
            }
        },
        {
            path: '/user',
            name: 'User',
            component: () => import('@/views/permission/user/user.vue'),
            meta: {
                keepAlive: true,
                title: 'demo.menu.User',
                authCode: ['U0001']
            }
        },
        {
            path: '/role',
            name: 'Role',
            component: () => import('@/views/permission/role/role.vue'),
            meta: {
                title: 'demo.menu.Role',
                authCode: ['U0002']
            }
        },
        {
            path: '/enumType',
            name: 'enumType',
            component: () => import('@/views/permission/device/enumType.vue'),
            meta: {
                title: 'demo.menu.EnumType',
                authCode: ['ENUM001']
            }
        },
        {
            path: '/personal',
            name: 'Personal',
            component: () => import('@/views/Personal/personal'),
            meta: {
                title: 'demo.menu.Personal',
                authCode: ['PERSON001']
            }
        },
        {
            path: '/addUser',
            name: 'addUser',
            hidden: true,
            component: () => import('@/views/permission/user/addUser.vue'),
            meta: {
                title: 'demo.menu.AddUser',
                authCode: ''
            }
        },
        {
            path: '/editUser',
            name: 'editUser',
            hidden: true,
            component: () => import('@/views/permission/user/editUser.vue'),
            meta: {
                title: 'demo.menu.EditUser',
                authCode: ''
            }
        },
        {
            path: '/allLog',
            name: 'allLog',
            hidden: true,
            component: () => import('@/views/permission/user/allLog.vue'),
            meta: {
                title: 'demo.menu.AllLog',
                authCode: ''
            }
        },
        {
            path: '/checkAccept',
            name: 'checkAccept',
            component: () => import('@/views/permission/user/checkAccept.vue'),
            meta: {
                title: 'demo.menu.Process',
                authCode: 'PROCESSMANAGEMENT'
            }
        }
    ]
}
